<div class="flex gap-2 md:gap-3">
  <p-card>
    <ng-template #title> {{ 'STATISTICS' | translate }}</ng-template>
    <ng-template #subtitle> {{ 'TOTAL' | translate }}</ng-template>
    <div>
      @if (playerProfileStatistics) {
        <div class="flex flex-column gap-1">
          <div class="flex justify-content-between align-items-center gap-2 md:gap-3">
            <span class="text-200 font-medium">{{ 'AVERAGE' | translate }}</span>
            <span class="text-100 font-semibold"
                  [pTooltip]="playerProfileStatistics.average > 0 ? ('1DA: Ø ' + (playerProfileStatistics.average | number:'1.1-1')) : ''" [showDelay]="400">
              @if (playerProfileStatistics.average > 0) {
                Ø&nbsp;{{ (playerProfileStatistics.average * 3) | number:'1.1-1' }}
              } @else {
                -
              }
            </span>
          </div>

          <div class="flex justify-content-between align-items-center gap-2 md:gap-3">
            <span class="text-200 font-medium">{{ 'MATCHES' | translate }}</span>
            <span class="text-100 font-semibold">
              @if (playerProfileStatistics.countMatches) {
                {{ playerProfileStatistics.countMatches }}
              } @else {
                -
              }
            </span>
          </div>

          <div class="flex justify-content-between align-items-center gap-2 md:gap-3">
            <span class="text-200 font-medium">{{ 'WON' | translate }}</span>
            <span class="text-100 font-semibold"
                  [pTooltip]="('WON' | translate) + ': ' + playerProfileStatistics.countWins" [showDelay]="400">
              @if (playerProfileStatistics.countMatches > 0) {
                {{ (playerProfileStatistics.countWins * 100 / playerProfileStatistics.countMatches) | number:'1.0-0' }}&nbsp;%
              } @else {
                -
              }
            </span>
          </div>
        </div>
      } @else {
        -
      }
    </div>
  </p-card>

  <p-card>
    <ng-template #title> {{ 'STATISTICS' | translate }}</ng-template>
    <ng-template #subtitle> {{ 'LAST_MONTH' | translate }}</ng-template>
    <div>
      @if (playerProfileStatistics) {
        <div class="flex flex-column gap-1">
          <div class="flex justify-content-between align-items-center gap-2 md:gap-3">
            <span class="text-200 font-medium">{{ 'AVERAGE' | translate }}</span>
            <span class="text-100 font-semibold"
                  [pTooltip]="playerProfileStatistics.averageLastMonth > 0 ? ('1DA: Ø ' + (playerProfileStatistics.averageLastMonth | number:'1.1-1')) : ''" [showDelay]="400">
              @if (playerProfileStatistics.averageLastMonth > 0) {
                Ø&nbsp;{{ (playerProfileStatistics.averageLastMonth * 3) | number:'1.1-1' }}
              } @else {
                -
              }
            </span>
          </div>

          <div class="flex justify-content-between align-items-center gap-2 md:gap-3">
            <span class="text-200 font-medium">{{ 'MATCHES' | translate }}</span>
            <span class="text-100 font-semibold">
              @if (playerProfileStatistics.countMatchesLastMonth) {
                {{ playerProfileStatistics.countMatchesLastMonth }}
              } @else {
                -
              }
            </span>
          </div>

          <div class="flex justify-content-between align-items-center gap-2 md:gap-3">
            <span class="text-200 font-medium">{{ 'WON' | translate }}</span>
            <span class="text-100 font-semibold"
                  [pTooltip]="('WON' | translate) + ': ' + playerProfileStatistics.countWinsLastMonth" [showDelay]="400">
              @if (playerProfileStatistics.countMatchesLastMonth > 0) {
                {{ (playerProfileStatistics.countWinsLastMonth * 100 / playerProfileStatistics.countMatchesLastMonth) | number:'1.0-0' }}&nbsp;%
              } @else {
                -
              }
            </span>
          </div>
        </div>
      } @else {
        -
      }
    </div>
  </p-card>
</div>
